import { render, staticRenderFns } from "./PhoneMobileIcon.vue?vue&type=template&id=387914fe&"
import script from "./PhoneMobileIcon.vue?vue&type=script&lang=js&"
export * from "./PhoneMobileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports